//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gsap } from 'gsap'
import IconView from "./IconView.vue";

const SKELETON_SLIDES_COUNT = 7

export default {
  name: "CarouselCategories",
  components: { IconView },
  data() {
    return {
      ready: false,
      swiper: null,
      menuItemsTween: null,
      navTreeItems: [],
      colors: [
        '#FB8B24',
        '#41B06E',
        '#7C73C0',
        '#D04848',
        '#7A4495',
        '#CD5888',
        '#325288',
        '#59C1BD'
      ],
    }
  },
  async fetch() {
    this.syncNavTreeItems()
  },
  computed: {
    isLoading() {
      return !this.ready
    },
    carouselSlides() {
      if (this.navTreeItems.length > 0) {
        return this.navTreeItems
      }
      if (!this.ready) {
        return Array.from({ length: SKELETON_SLIDES_COUNT }, (_, index) => ({
          id: `skeleton-${index}`,
          isPlaceholder: true,
        }))
      }
      return []
    },
  },
  created() {
    this.syncNavTreeItems()
  },
  mounted(){
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      const swiperEl = this.$refs.swiperContainer
      const initSwiper = async () => {
        this.ready = true
        await this.$nextTick()
        this.animateMenuItems()
      }

      this.$watch(
        () => this.$store.getters['categories/navTreeDetail'],
        () => {
          this.syncNavTreeItems()
        },
      )

      this.$watch('carouselSlides', (newVal) => {
        if (newVal && newVal.length > 0) {
          import('@/plugins/swiper.js')
            .then(({ Swiper, Navigation }) => {
              if (this.swiper) {
                this.swiper.destroy();
              }
              this.swiper = new Swiper(swiperEl, {
                autoHeight: true,
                preventClicks: true,
                preventClicksPropagation: true,
                touchStartPreventDefault: true,
                slidesPerView: 3,
                spaceBetween: 6,
                init: true,
                navigation: {
                  nextEl: `.btn-next`,
                  prevEl: `.btn-prev`,
                },
                modules: [Navigation],
                observer: true,
                observeParents: true,
                on: {
                  init: async (swiper) => {
                    await initSwiper()
                    swiper.updateAutoHeight(0)
                  },
                },
                breakpoints: {
                  750: {
                    slidesPerView: 4,
                    navigation: false
                  },
                  920: {
                    slidesPerView: 5,
                  },
                  1100: {
                    slidesPerView: 6,
                  },
                  1290: {
                    slidesPerView: 7,
                  }
                }
              })
            })
        }
      }, { immediate: true })
    }
  },
  beforeDestroy() {
    this.killMenuItemsAnimation()
    if (this.swiper) {
      this.swiper.destroy();
    }
  },
  methods:{
    killMenuItemsAnimation() {
      if (this.menuItemsTween) {
        this.menuItemsTween.kill()
        this.menuItemsTween = null
      }
      const wrappers = this.$el && this.$el.querySelectorAll('.menu-item__wrapper')
      if (wrappers && wrappers.length) {
        gsap.killTweensOf(wrappers)
      }
    },
    animateMenuItems() {
      // eslint-disable-next-line nuxt/no-env-in-hooks
      if (!process.client || !this.$el || !this.navTreeItems.length) {
        return
      }

      const targets = this.$el.querySelectorAll('.menu-item__wrapper')

      if (!targets.length) {
        return
      }

      this.killMenuItemsAnimation()

      gsap.set(targets, { opacity: 0, y: 18 })

      this.menuItemsTween = gsap.to(targets, {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: 'power2.out',
        stagger: 0.1,
        clearProps: 'transform',
      })
    },
    syncNavTreeItems() {
      const items = this.transformCategories(
        this.$store.getters['categories/navTreeDetail'],
      )
      if (items && items.length) {
        this.navTreeItems = items
      }
    },
    transformCategories(storeCategories) {
      let categories = null

      if(storeCategories){
        categories = []

        let indexCat = null;
        let category = null;

        let respCat = storeCategories.map(x => {
          const res = { ...x }
          delete res.items
          return res.node
        })

        for(indexCat in respCat){
          category = respCat[indexCat]

          categories.push({
            id: category.id,
            objects_url: `/s/${category.url}`,
            art_url: `/art?category=${category.url}`,
            icon: {
              path: `/public/object_categories_files/${category.id}/`,
              icon: category.icon,
              path_valid: !category.icon
            },
            label: category.label,
            stat:{
              objects_total: category.objects_total,
              materials_total: category.materials_total,
            }
          })
        }
      }

      return categories
    },
    getColor(index) {
      let color = this.colors[index % this.colors.length];

      return {
        backgroundColor: color
      };
    },
  }
}
